import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class EmailQuoteService {
    static emailQuote(quoteEmailDTO, isBundleProposal, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quote'),
            'emailQuote',
            [quoteEmailDTO, isBundleProposal],
            additionalHeaders
        );
    }
}
